import InterestModal from "@/core/components/modal";
import Overlay from "@/core/components/modal/overlay";
import { useDevice } from "@/core/hooks/useDevice";
import { useModalStore } from "@/store/modal/store";
import { AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KycRequiredModal = () => {
    const { t } = useTranslation();
    const { mobile } = useDevice();
    const { modal, setModal } = useModalStore();
    const navigate = useNavigate();
  
    const onClose = () => {
      setModal({ kycRequired: false });
    }

    const onConfirm = () => {
      setModal({ kycRequired: false });
      navigate('/on-boarding/synaps');
    }
  
    return (
      <AnimatePresence>
        {modal.kycRequired && (
          <Overlay close={onClose}>
            <InterestModal>
              <div className="general-modal" style={{ width: mobile ? '100%': '500px' }}>
                <div className="general-modal__header">
                  {t("modal.required")}
                </div>
                <div className="general-modal__content">
                  {t("modal.complete_kyc")}
                </div>
                <div className="general-modal__footer">
                  <button className={'cta-button cta-grey cta-medium'} onClick={onClose}>
                    {t("common.later")}

                  </button>
                  <button className={'cta-button cta-blue cta-medium'} onClick={onConfirm}>
                    {t("common.continue")}
                  </button>
                </div>
              </div>
            </InterestModal>
          </Overlay>
        )}
      </AnimatePresence>
    )
  }
  
  export default KycRequiredModal